import * as React from 'react';
import Head from '~/common/layout/Head';
import ReactSelect from 'react-select';


export default class TransactionListFilter extends React.Component<any, any> {
  filterRef;

  constructor(props) {
    super(props);
    this.filterRef = React.createRef();
  }

  onFilter = (e) => {
    e.preventDefault();

    this.props.onFilter(this.filterRef.current.value);
  };

  onLocationChange = (option) => {
    this.props.onLocationChange(option.value);
  };

  render = () => {
    const { locationHelper, filter, onLocationChange } = this.props;

    let options;

    if (filter.locationId) {
      options = [{value: null, label: 'Remove Filter'}].concat(locationHelper.options);
    } else {
      options = locationHelper.options;
    }

    return (
      <div className="filter__cont">
        <div className="filter__title" />
        <div className="filter__controls">
          {/*
          <ReactSelect
            className="filter--drop"
            placeholder="All Carriers"
            classNamePrefix="filter--drop"
          />
          */}
          {onLocationChange && (
            <ReactSelect
              name="locationId"
              label="Location"
              className="filter--drop"
              placeholder="All Locations"
              classNamePrefix="filter--drop"
              value={locationHelper.getSelectValue(filter.locationId)}
              options={options}
              onChange={this.onLocationChange}
              onInputChange={locationHelper.search}
              isLoading={!!locationHelper.isLoading}
            />
          )}

          <form onSubmit={this.onFilter}>
            <div className="input--search input--ti">
              <a onClick={this.onFilter} href="javascript:void(null)" className="input__icon input--search__btn">
                <span className="i i-search" />
              </a>
              <input type="text" placeholder="Search" ref={this.filterRef} defaultValue={filter && filter.q} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}
